import React, { useEffect } from 'react';

import {
  Box, Grid, Typography,
} from '@mui/material';

import { isEmpty } from 'lodash';

import {
  TextField,
  TextInput,
  required,
  useRecordContext,
} from 'react-admin';

import { useFormContext, useWatch } from 'react-hook-form';

import ArrayInput from './base/ArrayInput';
import cleaner from '../../../utilities/dataProvider/cleaner';
import { SourceOfFundsFormAnswer } from '../../kycForm/view/answers/SourceOfFunds';

type SourceOfFundsValue = string[];

const SourceOfFundsDialogBody = () => (
  <Grid container columnSpacing={6}>
    <Grid size={12}>
      <TextInput fullWidth source="source" label="Source" />
    </Grid>
  </Grid>

);

const ItemLabel = ({ value } : {value: Record<string, string>}) => {
  if (isEmpty(value)) return null;

  return (
    <Box display="flex" alignItems="center" gap={5}>
      <Typography
        variant="h6"
        color="primary.main"
      >
        {value.source}
      </Typography>
    </Box>
  );
};

export const SourceOfFundsAnswer = () => {
  const record = useRecordContext<{
    value: SourceOfFundsValue;
  }>();

  const value = (record?.value ?? []).join(', ');
  return <TextField record={{ value }} source="value" emptyText="-" fontWeight="bold" />;
};

export const sourceOfFundsFormatter = (
  datapointValue: SourceOfFundsValue,
): SourceOfFundsFormAnswer => ({
  options: datapointValue,
});

const SourceOfFunds = () => {
  const value = useWatch({ name: '_value' });
  const { setValue } = useFormContext();
  useEffect(() => {
    setValue('value', (value ?? []).flatMap((v: {source: string }) => v.source), { shouldDirty: true });
  }, [setValue, value]);

  return (
    <Grid container spacing={6}>
      <Grid size={12}>
        <Typography
          color="#646464"
          variant="h6"
          marginBottom={4}
        >
          Source of funds
        </Typography>
        <ArrayInput
          rootField="_value"
          title="Add source"
          itemNameSource="source"
          ItemLabel={ItemLabel}
          DialogBody={SourceOfFundsDialogBody}
          validate={required()}
          transformItemData={cleaner}
        />
      </Grid>
    </Grid>
  );
};

export default SourceOfFunds;
